<template>
  <b-card v-if="data" no-body >
    <b-card-header>
      <h4 class="mb-0">درصد پیشرفت</h4>
      <b-card-text class="font-medium-5 mb-0">
        <feather-icon
          icon="HelpCircleIcon"
          size="21"
          class="text-muted"
        />
      </b-card-text>
    </b-card-header>
    <div v-if="!Object.keys(PropProgress).length > 0" class="my-1">
      <b-skeleton
        class="mx-auto"
        type="avatar"
        width="200px"
        height="203px"
      ></b-skeleton>
    </div>
    <!-- apex chart -->
    <vue-apex-charts
      v-else-if="series"
      type="radialBar"
      height="250"
      class="mt-0 mb-2"
      :options="goalOverviewRadialBar"
      :series="data.series"
    />
    <b-row class="text-center mx-0">
      <b-col
        cols="6"
        class="border-top border-right d-flex align-items-center flex-column py-1"
      >
        <b-card-text class="text-muted mb-50"> تعداد کل جلسات </b-card-text>
        <b-skeleton v-if="!completed" width="60px"></b-skeleton>
        <h3 v-else class="font-weight-bolder ">
          {{ data.completed }}
        </h3>
      </b-col>

      <b-col
        cols="6"
        class="border-top d-flex align-items-center flex-column py-1"
      >
        <b-card-text class="text-muted mb-50"> جلسات دیده شده </b-card-text>
        <b-skeleton v-if="!inProgress" width="60px"></b-skeleton>
        <h3 v-else class="font-weight-bolder mb-0">
          {{ data.inProgress }}
        </h3>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BRow,
  BCol,
  BCardText,
  BSkeleton,
} from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import { $themeColors } from "@themeConfig";

const $strokeColor = "#ebe9f1";
const $textHeadingColor = "#5e5873";
const $goalStrokeColor2 = "#51e5a8";
export default {
  components: {
    VueApexCharts,
    BCard,
    BCardHeader,
    BRow,
    BCardText,
    BCol,
    BSkeleton,
  },

  data() {
    return {
      loading: false,
      data: {
        completed: "786,617",
        inProgress: "13,561",
        series: ["80"],
      },
      goalOverviewRadialBar: {
        chart: {
          height: 245,
          type: "radialBar",
          sparkline: {
            enabled: true,
          },
          dropShadow: {
            enabled: true,
            blur: 3,
            left: 1,
            top: 1,
            opacity: 0.1,
          },
        },
        colors: [$goalStrokeColor2],
        plotOptions: {
          radialBar: {
            offsetY: -10,
            startAngle: -150,
            endAngle: 150,
            hollow: {
              size: "77%",
            },
            track: {
              background: $strokeColor,
              strokeWidth: "50%",
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                color: $textHeadingColor,
                fontSize: "2.86rem",
                fontWeight: "600",
              },
            },
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            type: "horizontal",
            shadeIntensity: 0.5,
            gradientToColors: [$themeColors.success],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100],
          },
        },
        stroke: {
          lineCap: "round",
        },
        grid: {
          padding: {
            bottom: 30,
          },
        },
      },
    };
  },
  props: {
    PropProgress: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    completed() {
      return (this.data.completed = this.PropProgress.all);
    },
    inProgress() {
      return (this.data.inProgress = this.PropProgress.count_seen);
    },
    series() {
      return (this.data.series[0] = Math.ceil(
       this.PropProgress.count_seen  / this.PropProgress.all*100
      ));
    },
  },
};
</script>
